<h2 mat-dialog-title>Budget Recap</h2>

<mat-dialog-content>
    <gl-account-budget-recap-table [accounts]="accounts" [summaryDate]="summaryDate">
    </gl-account-budget-recap-table>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close telemetry="Submission-BudgetClose">
        Close
    </button>
</mat-dialog-actions>